export function partnerSerch() {
    $(document).on("click", ".partner-search-toggle", function () {
        $(this).toggleClass("active");
        $(".partner-search-box").stop().slideToggle();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/partner-serch.js